export default __webpack_public_path__ + "static/media/EAST1070.34I-34203_-18446_0.ec796957.jpg";